import axios from "axios";
import { environment } from "../../environments/environment";
import { ListResponse } from "./utils";

export interface User {
    username: string,
    email: string,
    first_name: string
};

export interface Candidate {
    id?: string,
    full_name: string,
    email: string,
    gender: string,
    date_of_birth: string,
    marital_status: string,
    education_level: string,
    disability: string,
    salary_expectation: number,
    cpf: string,
    rg: string,
    phone: string,
    mobile: string,
    status: string,
    address: string,
    city: string,
    cnh_category: string,
    usertype?: string,
    skills: number[]
};

export interface CreateCandidate {
    full_name: string,
    cpf: string,
    email: string,
    mobile: string,
    date_of_birth: string,
    password: string,
    gender: string,
    marital_status: string,
    salary_expectation: number | string,
    city_id: number | string,
    postcode?: string,
    address?: string,
    address_number?: string,
    address_district?: string,
    address_complement?: string,
    escola_do_mecanico_id?: number | string,
    skills: number[],
    has_experiences?: boolean
};

export const createCandidate = async (data: CreateCandidate): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/candidate/register/', data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 201) {
        throw Error('error');
    };

    return response.data;
};

export const retrieveCandidate = async (candidate_id?: string) => {
    const response = await axios.get<Candidate>(environment.apiUrl+'/api/candidate/'+(candidate_id ? candidate_id : localStorage.getItem('candidate_id')), {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const listCandidates = async () => {
    const response = await axios.get<ListResponse<Candidate>>(environment.apiUrl+'/api/candidates/', {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const updateCandidate = async (id: string, data: CreateCandidate): Promise<any> => {
    const response = await axios.put<any>(environment.apiUrl+'/api/candidate/'+id, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const downloadCandidateCV = async (candidate_id: string): Promise<Blob> => {
    try {
        const response = await axios.get(environment.apiUrl+`/api/candidate/${candidate_id}/cv?type=generate`, {
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if(response.status !== 200) {
            throw Error('Erro ao baixar o currículo');
        };

        return response.data;
    } catch (error: any) {
        // Se for erro 400, tentar extrair a mensagem de erro da resposta
        if (error.response?.status === 400) {
            try {
                // Converter o blob de erro para texto
                const errorText = await error.response.data.text();
                const errorJson = JSON.parse(errorText);
                
                // Se for erro de validação de perfil, mostrar mensagem específica
                if (errorJson.profile_incomplete || errorJson.missing_fields) {
                    const missingFields = errorJson.missing_fields || [];
                    const fieldsText = missingFields.length > 0 
                        ? `\n\nCampos obrigatórios faltantes:\n• ${missingFields.join('\n• ')}`
                        : '';
                    
                    throw new Error(
                        `${errorJson.profile_incomplete || 'Perfil incompleto'}${fieldsText}\n\nPara baixar seu currículo, complete as informações obrigatórias no seu perfil.`
                    );
                }
                
                throw new Error(errorJson.error || 'Não foi possível gerar o currículo do candidato');
            } catch (parseError) {
                throw new Error('Não foi possível gerar o currículo do candidato');
            }
        }
        
        // Para outros tipos de erro, usar a mensagem padrão
        throw new Error('Erro ao baixar o currículo. Verifique sua conexão e tente novamente. Caso persistir contate o suporte');
    }
};